import { useEffect, useState } from 'react';

import { matchSorter } from 'match-sorter';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

import { BoxlabelOptions } from '@/lib/reports/reportOptions';
// Constants
import { THREADS, X } from '@/lib/socialProfile';

import Checkbox from '@/components/base/Checkbox';
import Tooltip from '@/components/base/Tooltip';
// Components
import { DefaultSearchBox } from '@/components/composite/SearchBox/DefaultSearchBox';
import SocialProfileItem from '@/components/pages/reports/components/Items/Types/SocialProfileItem';

export const AccountItemCheckbox = ({ allItems, isSubmitting, checkValue, id, disabled }) => {
    const { t } = useTranslation('commons');

    if (!allItems?.length) {
        {
            BoxlabelOptions(t)[id].empty;
        }
    }
    return allItems.map((item, key) => {
        const isXProfile = item.type === X;
        const isThreadsProfile = item.type === THREADS;
        const isDisabledProfile = isXProfile || isThreadsProfile;

        const xTooltip = isXProfile ? t('x_export_disabled') : null;
        const threadsTooltip = isThreadsProfile ? t('threads_export_disabled') : null;
        const tooltipContent = xTooltip || threadsTooltip;

        return (
            <div className="flex items-center space-x-3.5" key={key}>
                <SocialProfileItem
                    item={item}
                    className={`flex-1 ${isDisabledProfile ? 'opacity-50' : ''}`}
                />

                <div className="ml-1">
                    <Tooltip content={tooltipContent} disabled={!isDisabledProfile}>
                        <div>
                            <Checkbox
                                id={item.id}
                                onChange={() => checkValue(item.id)}
                                checked={item?.selected ?? false}
                                disabled={isSubmitting || disabled || isDisabledProfile}
                            />
                        </div>
                    </Tooltip>
                </div>
            </div>
        );
    });
};

const AccountSearchKey = [
    { threshold: matchSorter.rankings.CONTAINS, key: 'username' },
    { threshold: matchSorter.rankings.CONTAINS, key: 'name' }
];

const SearchBoxAccount = ({ list, onSetList, errors, isLoading, disabled }) => {
    const { t } = useTranslation();
    const [castData, setCastData] = useState([]);

    useEffect(() => {
        let newList = [];
        newList = list.map((profile) => {
            const isXProfile = profile?.social_network_type === X;
            const isDisabledProfile = isXProfile;

            return {
                ...profile,
                avatar: profile?.external_api_data?.avatar,
                username: profile?.slug,
                name: profile?.external_api_data.name,
                type: profile?.social_network_type,
                selected: profile?.selected,
                disabled: isDisabledProfile
            };
        });

        setCastData(newList);
    }, []);

    const onSetValues = (values) => {
        const updatedData = castData.map((entry) => {
            const updatedEntry = values?.find((u) => entry?.id === u?.id);
            if (entry.type === X) {
                return {
                    ...entry,
                    disabled: true,
                    selected: false
                };
            }
            return updatedEntry ?? entry;
        });
        setCastData(updatedData);
        onSetList(values.filter((item) => item.selected && item.type !== X));
    };

    return (
        <DefaultSearchBox
            onSetValues={onSetValues}
            mutateList={null}
            errorList={null}
            searchKeys={AccountSearchKey}
            id="account"
            list={castData}
            errors={errors}
            isLoading={isLoading}
            disabled={disabled}
            noChoicesMessage={t('reports:general.account_no_items')}>
            {({ isSubmitting, checkValue, choices, id, disabled }) => {
                return (
                    <AccountItemCheckbox
                        allItems={choices}
                        isSubmitting={isSubmitting}
                        disabled={disabled}
                        checkValue={checkValue}
                        id={id}
                    />
                );
            }}
        </DefaultSearchBox>
    );
};

SearchBoxAccount.propTypes = {
    onSetList: PropTypes.func,
    list: PropTypes.array,
    errors: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool
};

export default SearchBoxAccount;
